export function initSlider($) {

    $(".slider.slider-standard").each(function (n, el) {
        let delay = parseInt($(el).data("delay"));

        if (isNaN(delay)) {
            delay = 8000;
        }

        $(".owl-carousel", el).owlCarousel({
            items: 1,
            loop: true,
            nav: true,
            dots: false,
            autoplay: false,
            autoplayTimeout: delay,
            autoplayHoverPause: true,
            smartSpeed: 1000,

            // animateIn: 'fadeIn',
            // animateOut: 'fadeOut',
        });
    });

    $(".slider.slider-block").each(function (n, el) {
        let $slider = $(".owl-carousel", el);
        let delay = parseInt($(el).data("delay"));
        let random = $(el).data("random");
        let isHero = $(el).hasClass("slider-hero");

        if (isNaN(delay)) {
            delay = 8000;
        }

        // randomise the slide order
        if (random) {
            for (var i = $slider[0].children.length; i >= 0; i--) {
                $slider[0].appendChild($slider[0].children[(Math.random() * i) | 0]);
            }
        }

        $slider.on("initialized.owl.carousel translated.owl.carousel refreshed.owl.carousel resized.owl.carousel", function () {
            if (isHero) {
                cleanupAnimationClasses($slider);
                swapHeroBackgrounds($slider);
            }
        });

        $slider.owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: true,
            autoplay: delay > 0,
            autoplayTimeout: delay,
            smartSpeed: 1500,

            animateIn: "fadeIn",
            animateOut: "fadeOut",
            //animateOut: 'slideOutUp',
            //animateIn: 'slideInUp'
        });

    });

    $(".slider.slider-events").each(function (n, el) {
        let $slider = $(".owl-carousel", el);
        let delay = parseInt($(el).data("delay"));

        if (isNaN(delay)) {
            delay = 8000;
        }

        $slider.on("initialized.owl.carousel translated.owl.carousel refreshed.owl.carousel", function () {
            cleanupAnimationClasses($slider);
        });

        $slider.owlCarousel({
            loop: true,
            nav: true,
            navText: ['<span class="fa-light fa-arrow-left"></span>', '<span class="fa-light fa-arrow-right"></span>'],
            dots: false,
            autoplay: delay > 0,
            autoplayTimeout: delay,
            smartSpeed: 1000,
            margin: 30,

            responsive: {
                0: {
                    items: 1,
                },
                576: {
                    items: 2,
                },
                960: {
                    items: 4,
                },
            },

            animateIn: "slideIn",
            animateOut: "slideOut",
        });

    });

    function cleanupAnimationClasses($carousel) {
        const carousel = $carousel.data("owl.carousel");

        if (!carousel || !carousel.settings) {
            return;
        }

        const animateIn = carousel.settings.animateIn;
        const animateOut = carousel.settings.animateOut;
        const baseClasses = "animated owl-animated-in owl-animated-out";

        $carousel
            .find(".owl-item")
            .css({ left: "" })
            .removeClass(baseClasses)
            .removeClass(animateIn || "")
            .removeClass(animateOut || "");
    }

    function swapHeroBackgrounds($slider) {
        const isMobile = window.innerWidth <= 768;

        $slider.find(".owl-item > .gb-container").each(function () {
            const $container = $(this);
            const containerEl = $container[0];
            if (!containerEl) return;

            let desktopBg = $container.attr("data-desktop-bg");
            let isCustomProp = $container.attr("data-is-custom-prop");

            if (!desktopBg) {
                let bgVal = containerEl.style.getPropertyValue('--background-image') || getComputedStyle(containerEl).getPropertyValue('--background-image');
                if (bgVal) {
                    bgVal = bgVal.trim();
                }

                if (bgVal && bgVal !== "none" && bgVal !== "") {
                    isCustomProp = "true";
                    $container.attr("data-is-custom-prop", "true");
                    $container.attr("data-desktop-bg", bgVal);
                    desktopBg = bgVal;
                } else {
                    bgVal = $container.css("background-image");
                    if (bgVal && bgVal !== "none") {
                        isCustomProp = "false";
                        $container.attr("data-is-custom-prop", "false");
                        $container.attr("data-desktop-bg", bgVal);
                        desktopBg = bgVal;
                    }
                }
            }

            const desktopMatch = desktopBg ? desktopBg.match(/(2000|1920)x770/) : null;
            if (desktopMatch) {
                const targetDimension = desktopMatch[0];
                const targetBg = isMobile ? desktopBg.replace(targetDimension, "768x1024") : desktopBg;
                if (isCustomProp === "true") {
                    containerEl.style.setProperty('--background-image', targetBg);
                } else {
                    $container.css("background-image", targetBg);
                }
            }
        });
    }
}